export default {
  // 报料详情接口
  getDiscloseMaterialInfo: '/member/anonymous/amc/getDiscloseMaterialInfo',
  // 查询报料频道
  listDiscloseChannelByCategoryCode: '/member/anonymous/amc/listDiscloseChannelByCategoryCode',
  // 获取频道下报料列表
  listDiscloseMaterialByPublish: '/member/anonymous/amc/listDiscloseMaterialByPublish',
  // 获取我的报料列表
  listDiscloseMaterialByMemberId: '/member/anonymous/amc/listDiscloseMaterialByMemberId',
  // 添加报料
  addDiscloseMaterial: '/member/anonymous/amc/addDiscloseMaterial',
}